import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Axios from '../../../axios/axios';
import { toast } from 'react-toastify';
import SupplierNavbar from './SuppplierNavbar';
import SupplierSidebar from './SupplierSidebar';
import { useLocation } from 'react-router-dom';


const SupplierProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [productType, setProductType] = useState(null); // Add productType state
  const [supplier, setSupplier] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();

useEffect(() => {
  if (window.innerWidth < 768) {
    setSidebarOpen(false);
  }
}, [location]);


  const navigate = useNavigate();

  const spanStyle = {
    maxWidth: '200px',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    lineHeight: '25px',
  };
  useEffect(() => {
    const storedSupplier = sessionStorage.getItem('supplierInfo');
    if (storedSupplier) {
      const supplierInfo = JSON.parse(storedSupplier);
      setSupplier(supplierInfo);
    }
  }, []);

  useEffect(() => {
    const fetchSupplierProducts = async () => {
      try {
        const supplierInfo = JSON.parse(sessionStorage.getItem('supplierInfo'));
        const response = await Axios.get(`suppliers/${supplierInfo.supplierId}`);
        setProducts(response.data.products);
      } catch (error) {
        toast.error('Error fetching products: ' + error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSupplierProducts();
  }, [navigate]);

  const handleConfirmedDelete = async () => {
    try {
      const supplierInfo = JSON.parse(sessionStorage.getItem('supplierInfo'));

      // Determine the correct API endpoint based on product category
      let endpoint = '';
   if (supplierInfo?.productCategory === 'Engineering') {
  endpoint = `/engineeringpart/delete/${deleteId}`;
} else if (supplierInfo?.productCategory === 'Building') {
  endpoint = `/meterials/delete/${deleteId}`;
} else if (supplierInfo?.productCategory === 'Rental') {
  endpoint = `/rental/delete/${deleteId}`;
} else {
  endpoint = `/parts/delete/${deleteId}`;
}

      await Axios.delete(endpoint);
      toast.success('Deleted successfully');
      setProducts(products.filter((p) => p._id !== deleteId));
    } catch (error) {
      toast.error('Error deleting product: ' + error.message);
    } finally {
      setShowModal(false);
      setDeleteId(null);
      setProductType(null);
    }
  };

  // Alternative approach if you want to handle delete based on productType stored in each product
  const handleDeleteClick = (productId, type) => {
    setDeleteId(productId);
    setProductType(type); // Store the product type
    setShowModal(true);
  };

  const toTitleCase = (str) => {
    return str
      ? str.replace(/\w\S*/g, (txt) => {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        })
      : 'N/A';
  };

  if (loading) {
    return <div className="text-center mt-5">Loading products...</div>;
  }

  const handleCreateClick = () => {
    const supplierInfo = JSON.parse(sessionStorage.getItem('supplierInfo'));
if (supplierInfo?.productCategory === 'Engineering') {
  navigate('/engproduct');
} else if (supplierInfo?.productCategory === 'Building') {
  navigate('/bldproduct');
} else if (supplierInfo?.productCategory === 'Rental') {
  navigate('/rentalproduct');
} else {
  navigate('/spareproduct');
}
  };

  const handleEditClick = (productId, productType) => {
    const supplierInfo = JSON.parse(sessionStorage.getItem('supplierInfo'));
   if (supplierInfo?.productCategory === 'Engineering') {
  navigate(`/engedit/${productId}?type=${productType}`);
} else if (supplierInfo?.productCategory === 'Building') {
  navigate(`/bldedit/${productId}?type=${productType}`);
} else if (supplierInfo?.productCategory === 'Rental') {
  navigate(`/rentaledit/${productId}?type=${productType}`);
} else {
  navigate(`/spare-edit/${productId}?type=${productType}`);
}
  };


  return (
    <div className="enhanced-body">
      <SupplierNavbar
        supplier={supplier}
        setSupplier={setSupplier}
        toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
      />
      <div className="container-fluid">
        <div className="row">
          {sidebarOpen && (
            <div className="col-md-2">
                                      <SupplierSidebar closeSidebar={() => {
              if (window.innerWidth < 768) setSidebarOpen(false);
            }} />
            </div>
          )}
          <div className={sidebarOpen ? 'col-md-10' : 'col-md-12'}>
            <div className="dashboard-main">
              {' '}
              <div className="row">
                <div className="col-lg-12 grid-margin stretch-card">
                  <div
                    className="card"
                    style={{ maxHeight: '80vh', overflowY: 'auto' }}
                  >
                    <div className="card-body">
                      <h4 className="card-title">My Products</h4>
                      <div className="float-right">
                        <button
                          type="button"
                          className="btn btn-primary btn-md btn-block"
                          onClick={handleCreateClick}
                        >
                          <i className="icon-plus menu-icon"></i>
                          Create
                        </button>
                      </div>

                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Name</th>
                              <th>Part No</th>
                              <th>Brand</th>
                              <th>Model</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {products.length > 0 ? (
                              products.map((product, index) => (
                                <tr key={product._id}>
                                  <td>{index + 1}</td>
                                  <td>
                                    <span style={spanStyle}>
                                      {toTitleCase(product.name || product.partName || product.meterialName || product.rentalItem)}

                                    </span>
                                  </td>
                                  <td>{product.partNo || 'N/A'}</td>
                                  <td>
                                    {toTitleCase(
                                      product.brandId?.name || 'N/A'
                                    )}
                                  </td>
                                  <td>
                                    {toTitleCase(
                                      product.modelId?.name || 'N/A'
                                    )}
                                  </td>
                                  <td>
                                    <div className="d-flex flex-row">
                                      <div className="p-2">
                                        <button
                                          type="button"
                                          className="btn btn-outline-dark btn-sm"
                                          onClick={() =>
                                            handleEditClick(
                                              product._id,
                                              product.productType
                                            )
                                          }
                                        >
                                          Edit
                                        </button>
                                      </div>
                                      <div className="p-2">
                                        <button
                                          type="button"
                                          className="btn btn-outline-danger btn-sm"
                                          onClick={() =>
                                            handleDeleteClick(
                                              product._id,
                                              product.productType
                                            )
                                          }
                                        >
                                          Delete
                                        </button>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="7" className="text-center">
                                  No products found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Delete Confirmation Modal */}
                {showModal && (
                  <div className="modal show" style={{ display: 'block' }}>
                    <div className="modal-dialog">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Confirm Delete</h5>
                          <button
                            type="button"
                            className="close"
                            onClick={() => setShowModal(false)}
                          >
                            <span>&times;</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <p>Are you sure you want to delete this product?</p>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => setShowModal(false)}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={handleConfirmedDelete}
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupplierProducts;
